// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"fdd6e4a2","206":"ae478117","233":"5f380575","453":"d855a71b","510":"63d488a1","675":"c54264cf","814":"93655536","875":"528ca476"}[chunkId] + ".chunk.js";
};